<template lang="pug">
label.toggle-switch-wrapper(:disabled="disabled ? 'disabled' : null")
  input(
    type="checkbox"
    autocomplete="off"
    :checked="modelCompatValue"
    :disabled="disabled"
    @click="onClick"
  )
  .toggle-switch
  span.toggle-switch-label
    slot
</template>

<script>
import VModelCompat from '~/mixins/v_model_compat';

export default {
  name: 'AppOnOffToggle',
  mixins: [VModelCompat],
  props: {
    modelValue: {
      type: Boolean,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'input'],
  methods: {
    onClick(event) {
      this.emitModelCompatValue(!this.modelCompatValue, event);
    },
  },
};
</script>
